import { AfterViewInit, Directive, ElementRef } from '@angular/core';

@Directive({
    selector: '[ngcAutofocus]'
})
export class AutofocusDirective implements AfterViewInit {
    constructor(private el: ElementRef) {}

    ngAfterViewInit() {
        setTimeout(() => {
            this.el.nativeElement.focus();
        });
    }
}
